import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGluuComponent } from './authgluu.component';
import { FormsModule }   from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule],
  declarations: [AuthGluuComponent],
  exports: [AuthGluuComponent]
})

export class AuthGluuModule { }
